import React from "react";

import { Button, Form, Col, Row, Modal, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";

import styles from "../css/receiptManagement.module.css";

const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

// form schema definition
const formSchema = Yup.object().shape({
  prioritySearch: Yup.object({}),
  referenceNumber: Yup.string()
    .required("*Please input a reference number.")
    .max(10, "*Incorrect length"),
  description: Yup.string()
    .required("*Please input information on the service provided.")
    .max(300, "*Description must be 300 characters or less.")
});

export const ServiceRender = ({ otpVerified, cancel, receiptInfo, onHandleServiceRender, display, onCloseModal, updatedReceipt, updatingRcptStat }) => {

  const initialValues = {
    referenceNumber: "",
    description: ""
  };

  const handleReceiptUpdate = (values) => {
    let query = {
      refNumber: values.referenceNumber,
      description: values.description
    };

    onHandleServiceRender(query);
  };

  
  return (
    <Modal show={display} size="lg" aria-labelledby="contained-modal-title-vcenter" centered >
      {/* Header */}
      
      <Modal.Header style={{display: "inline"}} closeButton>
        <Modal.Title>
          <Row>
            <Col lg={6} md={12} sm={12}>
              Receipt No: <b>{receiptInfo.rcpt_number}</b>
            </Col>
            <Col lg={6} md={12} sm={12}>
              Receipt Status: <span className="text-primary"> {receiptInfo.rcpt_status_desc} </span>
            </Col>
          </Row>
        </Modal.Title>
      </Modal.Header>
      

      {/* Body */}

      <Modal.Body className={styles.serviceRenderModal} style={{fontSize:"16px"}}>
      <>
        <Row>
          <Col lg={2} md={12} sm={12}>
            <b>Customer:</b>
          </Col>
          <Col lg={4} md={12} sm={12}>
            {receiptInfo.cust_first_name + " " + receiptInfo.cust_last_name} 
          </Col> 
          <Col lg={2} md={12} sm={12}>
            <b>Mobile No:</b>
          </Col>
          <Col lg={4} md={12} sm={12}>
            {receiptInfo.cust_msisdn}
          </Col>
        </Row>
        <Row>
          <Col lg={2} md={12} sm={12}>
            <b>Department:</b>
          </Col>
          <Col lg={4} md={12} sm={12}>
            {receiptInfo.dept_name}
          </Col>
          <Col lg={2} md={12} sm={12}>
            <b>Province:</b>
          </Col>
          <Col lg={4} md={12} sm={12}>
            {receiptInfo.province_name}
          </Col>
        </Row>
        <Row>
          <Col lg={2} md={12} sm={12}>
            <b>Service Type:</b>
          </Col>
          <Col lg={4} md={12} sm={12}>
            {receiptInfo.service_name}
          </Col>
          <Col lg={2} md={12} sm={12}>
            <b>Service Item:</b>
          </Col>
          <Col lg={4} md={12} sm={12}>
            {receiptInfo.service_item_desc}
          </Col>
        </Row>
        <Row>
          <Col lg={2} md={12} sm={12}>
            <b>Amount:</b> 
          </Col>
          <Col lg={4} md={12} sm={12}>
            {moneyFormater.format(receiptInfo.total_amnt)}
          </Col>
        </Row>
      </>

        <hr/>

        <p style={{fontSize:"16px"}}>
          Receipt No. <b>{receiptInfo.rcpt_number}</b> status will be changed from <span className="text-primary"> <b>ISSUED</b> </span> to <span className="text-success"> <b>USED</b> </span> as proof that service, <br/>
          <b> {receiptInfo.service_item_number}: {receiptInfo.service_item_desc}</b> has been rendered to <b>{receiptInfo.cust_first_name + " " + receiptInfo.cust_last_name}</b>.

          <br></br>
          <br></br>
          Please enter a reference number and brief description for the service being rendered.
        </p>

        <hr/>

        <Formik
          validationSchema={formSchema}
          initialValues={initialValues}
          onSubmit={(values, {setSubmitting}) => {
            
            setSubmitting(true);
            handleReceiptUpdate(values);
            setSubmitting(false);
          }}
          className={styles.serviceRenderModal} 
          style={{fontSize:"14px"}}
        >
          {( {values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, handleReset} ) => (
            <Form onSubmit={handleSubmit}>
              <Form.Row>
                <Col lg md={12} sm={12}>
                  <Form.Group controlId="paramRefNumber">
                    <Form.Label> <b> Reference Number: </b> </Form.Label>
                    <Form.Control
                      name="referenceNumber"
                      placeholder="Enter reference number"
                      value={values.referenceNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={touched.referenceNumber && errors.referenceNumber && { border: "1px solid red",  boxShadow: "0 0 5px #F47174" } }
                    />
                    {touched.referenceNumber && errors.referenceNumber ? <div className={styles.formErrorMsg}>{errors.referenceNumber}</div> : null}
                  </Form.Group>
                </Col>
              </Form.Row>
              <Form.Row>
                <Col lg md={12} sm={12}>
                  <Form.Group controlId="paramDescription">
                    <Form.Label> <b> Description: </b> </Form.Label>
                    <Form.Control
                      as="textarea"
                      name="description"
                      placeholder="Enter description number"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={touched.description && errors.description && { border: "1px solid red",  boxShadow: "0 0 5px #F47174" } }
                    />
                    {touched.description && errors.description ? <div className={styles.formErrorMsg}>{errors.description}</div> : null}
                  </Form.Group>
                </Col>
              </Form.Row>
              <Button variant="primary" type="submit" style={{ display: "flex", alignItems: "center"}}>
                Update Receipt &nbsp;
                { updatingRcptStat && <Spinner animation="border" size="sm" /> }
              </Button>
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={cancel} > Close </Button>
      </Modal.Footer>
    </Modal>
  );
};
